export const UserRoles = {
  ADMIN: 'admin',
  MEMBER: 'member'
};